import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To install private npm packages in a Docker container, you will need to use `}<a parentName="p" {...{
        "href": "https://docs.docker.com/develop/develop-images/build_enhancements/#new-docker-build-secret-information"
      }}>{`Docker build secrets`}</a>{`.`}</p>
    <h2>{`Background: runtime variables`}</h2>
    <p>{`You cannot install private npm packages in a Docker container using only runtime variables. Consider the following Dockerfile:`}</p>
    <pre><code parentName="pre" {...{}}>{`FROM node

COPY package.json package.json
RUN npm install

# Add your source files
COPY . .
CMD npm start
`}</code></pre>
    <p>{`Which will use the official `}<a parentName="p" {...{
        "href": "https://hub.docker.com/_/node"
      }}>{`Node.js`}</a>{` image, copy the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` into our container, installs dependencies, copies the source files and runs the start command as specified in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`In order to install private packages, you may think that we could just add a line before we run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`, using the `}<a parentName="p" {...{
        "href": "https://docs.docker.com/engine/reference/builder/#env"
      }}>{`ENV parameter`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-docker"
      }}>{`ENV NPM_TOKEN=00000000-0000-0000-0000-000000000000
`}</code></pre>
    <p>{`However, this doesn't work as you would expect, because you want the npm install to occur when you run `}<inlineCode parentName="p">{`docker build`}</inlineCode>{`, and in this instance, `}<inlineCode parentName="p">{`ENV`}</inlineCode>{` variables aren't used, they are set for runtime only.`}</p>
    <p>{`Instead of run-time variables, you must use Docker build secrets.`}</p>
    <h2>{`Update the Dockerfile`}</h2>
    <p>{`The Dockerfile that takes advantage of this has a few more lines in it than the earlier example that allows us to use your global `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` and the access token created when running `}<inlineCode parentName="p">{`npm login`}</inlineCode>{` command (if you haven't run it already - do so before moving on).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-dockerfile"
      }}>{`# https://docs.npmjs.com/docker-and-private-modules
FROM node:16

ENV APP_HOME="/app"

WORKDIR \${APP_HOME}

COPY package*.json \${APP_HOME}/

RUN --mount=type=secret,id=npmrc,target=/root/.npmrc npm install

COPY . \${APP_HOME}/

CMD npm start

`}</code></pre>
    <p>{`This will configure your Dockerfile to receive `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file via build secrets, that will leave no trace after npm dependency installation is done.`}</p>
    <h2>{`Build the Docker image`}</h2>
    <p>{`To build the image using the above Dockerfile and the npm authentication token, you can run the following command. Note the `}<inlineCode parentName="p">{`.`}</inlineCode>{` at the end to give `}<inlineCode parentName="p">{`docker build`}</inlineCode>{` the current directory as an argument.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`docker build . -t secure-app-secrets:1.0 --secret id=npmrc,src=$HOME/.npmrc
`}</code></pre>
    <p>{`This will build the Docker image with the access token coming from your global `}<inlineCode parentName="p">{`.npmrc`}</inlineCode>{` file received via build secrets, so you can run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` inside your container as the current logged-in user.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You may need to specify a working directory different from the default `}<inlineCode parentName="p">{`/`}</inlineCode>{` otherwise some frameworks like Angular will fail.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      